import { atom } from "jotai";
import type { RefObject } from "react";

/**
 * Atom to store a reference to the questionnaire form element.
 * This allows multiple hooks to access the same form ref for native form submission.
 */
export const questionnaireFormRefAtom =
  atom<RefObject<HTMLFormElement | null> | null>(null);
